export const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

/**
 * Index to focus for a Tab press inside a modal dialog, cycling in both
 * directions. The trap always moves focus itself: if the focused control was
 * removed or disabled, focus has already fallen to <body> (index -1) and the
 * browser's default Tab would leave the dialog. Returns -1 only when the
 * dialog has no focusable elements.
 */
export function nextTrapIndex(count, currentIndex, shiftKey) {
  if (count === 0) return -1;
  if (currentIndex === -1) return shiftKey ? count - 1 : 0;
  return (currentIndex + (shiftKey ? -1 : 1) + count) % count;
}
